import {
  BatchSetting,
  ProductChangeover,
  ProductSetting,
} from 'Features/Projects/Scenarios/EditSettings/LineSettings/LineSettings.types'
import { createContext, Dispatch, useContext } from 'react'
import { ReplenishmentSiteSku } from 'Features/Projects/Scenarios/EditSettings/NetworkSettings/Replenishment/Replenishment.types'
import { Scenario } from 'Features/Projects/Scenarios/Scenarios.types'
import {
  Status,
  PreferredMethod,
} from 'Features/Projects/Scenarios/Templates/PlanTemplateSummary.types'

export type BaseSourceSiteWorkCentre = {
  id: number
  baseSourceSiteKey: number
  baseSourceSiteCode: string
  workcentreCode: string
  workCentreKey: number
  workcentreCapacity: number
  headSpaceBuffer: number
  skuGroupCount: number
  preferredTemplate: PreferredMethod
  unconstrainedStatus: Status
  constrainedStatus: Status
  costOptimizedStatus: Status
  carbonCostStatus: Status
  campaignStatus: Status
}

export type SettingsState = {
  projectId: string
  scenarioId: string
  // productSettings: ProductSetting[]
  // batchSettings: BatchSetting[]
  // productChangeovers: ProductChangeover[]
  // baseSourceSiteWorkCentre: BaseSourceSiteWorkCentre[]
  selectedBaseSourceSite: string
  selectedWorkCentre: string
  //replenishmentSiteSkus: ReplenishmentSiteSku[]
  scenarios: Scenario[]
  selectedScenario: string
}

export type Action =
  | { type: 'UPDATE_PROJECT_ID'; payload: string }
  | { type: 'UPDATE_SCENARIO_ID'; payload: string }
  | { type: 'UPDATE_SKU_SALES_RATE'; payload: number }
  | { type: 'UPDATE_SKU_MIN_CYCLE'; payload: number }
  | { type: 'UPDATE_SKU_MAX_CYCLE'; payload: number }
  | { type: 'UPDATE_SKU_RUN_RATE' }
  | { type: 'PRODUCT_SETTINGS_FETCH'; payload: ProductSetting[] }
  | { type: 'PRODUCT_CHANGEOVERS_FETCH'; payload: ProductChangeover[] }
  | { type: 'BATCH_SETTINGS_FETCH'; payload: BatchSetting[] }
  | { type: 'BASE_SOURCE_SITE_FETCH'; payload: BaseSourceSiteWorkCentre[] }
  | { type: 'REPLENISHMENT_SITE_SKUS_FETCH'; payload: ReplenishmentSiteSku[] }
  | { type: 'PROJECT_DETAILS_FETCH'; payload: Scenario[] }
  | { type: 'UPDATE_SELECTED_SCENARIO'; payload: string }
  | { type: 'UPDATE_BASE_SOURCE_SITE'; payload: string }
  | { type: 'UPDATE_WORKCENTRE'; payload: string }
  | { type: 'RESET_DROPDOWN_OPTIONS' }
  | { type: 'UPDATE_STATE'; payload: SettingsState }
  | { type: 'SET_SKU_CYCLES_TO_CURRENT' }

export const settingsReducer = (
  state: SettingsState,
  action: Action
): SettingsState => {
  switch (action.type) {
    case 'UPDATE_STATE':
      return action.payload
    case 'UPDATE_PROJECT_ID':
      return {
        ...state,
        projectId: action.payload,
      }
    case 'UPDATE_SCENARIO_ID':
      return {
        ...state,
        scenarioId: action.payload,
      }

    case 'PROJECT_DETAILS_FETCH':
      return {
        ...state,
        scenarios: action.payload,
      }
    case 'UPDATE_SELECTED_SCENARIO':
      return {
        ...state,
        selectedScenario: action.payload,
      }
    case 'UPDATE_BASE_SOURCE_SITE':
      return {
        ...state,
        selectedBaseSourceSite: action.payload,
        selectedWorkCentre: 'All',
      }
    case 'UPDATE_WORKCENTRE':
      return {
        ...state,
        selectedWorkCentre: action.payload,
      }
    case 'RESET_DROPDOWN_OPTIONS':
      return {
        ...state,
        selectedWorkCentre: 'All',
        selectedBaseSourceSite: 'All',
      }

    // case 'SET_SKU_CYCLES_TO_CURRENT':
    //   return {
    //     ...state,
    //     productSettings: state.productSettings.map((item: ProductSetting) => {
    //       return {
    //         ...item,
    //         minCycleInput: item.currentCycleTime,
    //         maxCycleInput: item.currentCycleTime,
    //       }
    //     }),
    //   }
    default:
      return state
  }
}

export type SettingsContextType = {
  state: SettingsState
  dispatch: Dispatch<Action>
}

export const SettingsContext = createContext<SettingsContextType | undefined>(
  undefined
)

export const useSettingsContext = (): SettingsContextType => {
  const context = useContext(SettingsContext)
  if (!context) throw new Error('Must be within Settings Provider')
  return context
}
